import useQueryParam, { QUERY_STRING_KEYS } from "hooks/useQueryParam";

const useSelectedContractDocEntry = () => {
  const [selectedContractDocEntry] = useQueryParam(
    QUERY_STRING_KEYS.SELECTED_CONTRACT_KEY
  );
  return selectedContractDocEntry
    ? parseInt(selectedContractDocEntry)
    : undefined;
};

export default useSelectedContractDocEntry;
